import React, { useEffect, createElement } from 'react';
interface PageSEOProps {
  title: string;
  description: string;
  path: string;
  ogImage?: string;
  keywords?: string;
  ogType?: string;
  author?: string;
  /** Keep the page out of search engines — for unlisted, link-only pages */
  noIndex?: boolean;
}
function setMetaTag(name: string, content: string, isProperty = false) {
  const attr = isProperty ? 'property' : 'name';
  let element = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attr, name);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
}
export function PageSEO({
  title,
  description,
  path,
  ogImage,
  keywords,
  ogType,
  author,
  noIndex = false
}: PageSEOProps) {
  const siteUrl = 'https://www.vitalityvf.com';
  const defaultImage = 'https://cdn.magicpatterns.com/uploads/rLCDkCKprcJW1NkEV2aCi1/Vitality_Logo_Circle.png';
  const fullUrl = `${siteUrl}${path}`;
  const image = ogImage || defaultImage;
  useEffect(() => {
    // Page title
    document.title = title;
    // Standard meta
    setMetaTag('description', description);
    setMetaTag('robots', noIndex ? 'noindex, nofollow, noarchive, nosnippet' : 'index, follow, max-snippet:-1, max-image-preview:large');
    setMetaTag('author', author || 'Vitality Venture Fund');
    // Language hint for answer engines
    document.documentElement.setAttribute('lang', 'en');
    // Keywords (if provided)
    if (keywords) {
      setMetaTag('keywords', keywords);
    }
    // Open Graph
    setMetaTag('og:title', title, true);
    setMetaTag('og:description', description, true);
    setMetaTag('og:url', fullUrl, true);
    setMetaTag('og:image', image, true);
    setMetaTag('og:type', ogType || 'website', true);
    setMetaTag('og:site_name', 'Vitality Venture Fund', true);
    setMetaTag('og:locale', 'en_US', true);
    // Twitter Card
    setMetaTag('twitter:card', 'summary_large_image');
    setMetaTag('twitter:title', title);
    setMetaTag('twitter:description', description);
    setMetaTag('twitter:image', image);
    // Answer engine hints
    setMetaTag('article:author', 'Vitality Venture Fund', true);
    setMetaTag('article:publisher', 'https://www.vitalityvf.com', true);
    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', fullUrl);
  }, [title, description, fullUrl, image, keywords, ogType, author, noIndex]);
  return null;
}